import { doHttp2 } from '../utils/common'
import { HTTP_TYPE_POST, HTTP_TYPE_GET } from '../utils/config'

/**
 * 产品信息查询
 * @param code
 * @return {*}
 */
export function apiDetail (code) {
  let params = {
    code
  }
  return doHttp2('/webservice/Label/detail.ws', HTTP_TYPE_GET, params)
}
